export default __webpack_public_path__ + "static/media/khipu_payku.6177fe27.svg";